import { useQuery } from '@tanstack/react-query'

import fetchRequest from '@/app/_utils/fetch-request'

import { QueryKeys } from '../react-query'

// 🚨 IMPORTANT: jwtToken is used to check if the user is logged in in useUser hook.
// DONT CHANGE IT WITHOUT CONSULTING.

export function useJwtToken() {
    return useQuery({
        queryKey: QueryKeys.User.JwtToken,
        queryFn: async () => {
            const data: string = await fetchRequest({
                method: 'GET',
                serviceName: 'pam',
                endpoint: `/users/_current/jwt`,
                openAuthModal: false,
            })

            return data
        },
        staleTime: Infinity,
        retry: false,
    })
}
